<!-- <p>asset-tile works!</p> -->
<div class="vib-sensor mat-elevation-z8" [id]="asset.AssetID" [title]="!editing ? asset.Description : ''" [ngClass]="{
				'actioned': asset.Actioned == true,
				'watchActive': asset.Watch == true,
				'AssetSelected': selectedAsset?.AssetID === asset.AssetID && !isFullScreen && !editing,
                'AssetSelectedFS': selectedAsset?.AssetID === asset.AssetID && isFullScreen && !editing,
                'editing': editing,
                'no-hover': editing
			}" [style.left]="!editing ? getSafePosition(asset.LeftPosition) + '%' : ''"
    [style.top]="!editing ? getSafePosition(asset.TopPosition) + '%' : ''" [style.fontSize.px]="textSize"
    [hidden]="!asset.DisplayOnImage" [ngStyle]="{
        'padding-left': (SIValues.length > 0 || editing) ? '1em' : '', 
        'padding-right': (SIValues.length > 0 || editing) ? '1em' : '',
        'background-color': backgroundColour
    }">
    <span class="name">{{asset.Name}}</span>

    <span class="kpi" *ngFor="let item of SIValues" matTooltip="{{item.timeDifference}}min" title="{{isFullScreen ? item.timeDifference + 'min' : ''}}">
        {{duplicateSIs ? item.datapoint.SensorName + ' ' : ''}}{{item.value}}{{item.SI}}
    </span>

    <div class="cornerBoxes" *ngIf="dataPoints.length > 0 && false"> <!--TODO: currently hidden, unhide when it works-->
        <div *ngFor="let i of [].constructor(numberOfKPIs); let idx = index"
            [ngClass]="{'full-row': (numberOfKPIs % 2 != 0 && idx == 0)}"
            [ngStyle]="{'width': (numberOfKPIs % 2 != 0 && idx == 0) ? '10em' : '5em'}">
            <ejs-dropdownlist *ngIf="!indexHasDatapoints(idx)" #dropdown [dataSource]="getAvailableDatapoints(idx)"
                [fields]="dataPointFields" [popupWidth]="(numberOfKPIs % 2 != 0 && idx == 0) ? '150%' : '300%'"
                (change)="selectKPI($event, idx)">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{ data.DPTitle }}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
            <span *ngIf="indexHasDatapoints(idx) && getSIValue(idx) as siValue" class="kpi"
                [matTooltip]="siValue.datapoint ? siValue.datapoint.DPTitle : ''">{{siValue.value}}{{siValue.SI}}</span>
        </div>
    </div>

    <mat-icon [ngStyle]="{'font-size.px': iconSize, 'width.px': iconSize, 'height.px': iconSize}"
        *ngIf=" (asset.Watch && !asset.Actioned) && showWatchIcons && !editing"
        style="margin-left: var(--default-margin);">visibility</mat-icon>
    <mat-icon [ngStyle]="{'font-size.px': iconSize, 'width.px': iconSize, 'height.px': iconSize}"
        *ngIf=" asset.Actioned == true && showWatchIcons && !editing"
        style="margin-left: var(--default-margin);">content_paste</mat-icon>
</div>